import * as types from "../../../mutation-types";

export default {
  [types.SET_AUTHX_APP](state, authx_app) {
    state.authx_app = authx_app;
  }
};
